// used at build time, so no TypeScript
import defaultConfig from "./default";
import productionConfig from "./prod";
import developmentConfig from "./dev";
import localConfig from "./local";
const { NODE_ENV, APP_ENV } = defaultConfig;

let runningConfig = defaultConfig;

const isProd = APP_ENV === "production" && NODE_ENV === "production";
const isDev = APP_ENV === "dev" && NODE_ENV === "production";
const isLocal = APP_ENV === "local" && NODE_ENV === "development";

if (isProd) {
  runningConfig = productionConfig;
} else if (isDev) {
  runningConfig = developmentConfig;
} else if (isLocal) {
  runningConfig = localConfig;
}

export default runningConfig;
